<template>
  <div>
    <div id="appLoading">
      <span>Loading...</span>
    </div>
    <div id="appLoaded" style="display: none">
      <el-container>
        <el-header style="text-align: center; font-size: 20px;font-weight: bold">
          <span>BooleanDA 收银台</span>
        </el-header>
        <el-main>
          <div class="tab-item">
            <el-tabs type="border-card" :value="indexNum" @tab-click="getTab">
              <el-tab-pane v-for="(item, index) of tabMenu" :key="index" :label="item.title" :disabled="item.name===param.oname?false:index===0?false:true">
                <div class="car">
                  <PayBill v-for="(it, ind) of item.values" :key="ind" :my-name="it" :my-index="selectNum" @handleChange="changeName"/>
<!--                  {{item.values[1].amount}}-->
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
<!--          <div class="main">-->
<!--            <div class="main-img">-->
<!--              <div class="block">-->
<!--                <el-image :src="src1" class="img" :class="{ 'active': isActive1 }" @click="handle1"></el-image>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="main-img">-->
<!--              <div class="block">-->
<!--                <el-image :src="src2" class="img" :class="{ 'active': isActive2 }" @click="handle2"></el-image>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="main-img">-->
<!--              <div class="block">-->
<!--                <el-image :src="src3" class="img" :class="{ 'active': isActive3 }" @click="handle3"></el-image>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="clearfix"></div>
          <div style="margin-top:60px;"></div>
          <div class="content">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
              <el-form-item label="手机号：" prop="input1">
                <el-input v-model.number="ruleForm.input1" placeholder="请输入手机号" maxlength="11" show-word-limit></el-input>
                <!--                <el-alert title="*提示：近期短信平台在开展安全审核，建议使用联通、电信号码，移动仍在审核中暂无法正常发送验证码，如确实需使用移动，在登录时请联系QQ客服手动发验证码！" type="warning" />-->
              </el-form-item>
              <div :style="{'display':isActive3?'block':'none'}">
                <el-form-item label="序列号：" prop="input2">
                  <el-input v-model="ruleForm.input2" placeholder="请输入序列号" maxlength="16" show-word-limit></el-input>
                  <span style="color: red">*注意：序列号必须是在最终使用的（单机离线）机器上获取！！</span>
                  <span class="txt-btn" @click="handle4"><i class="el-icon-warning-outline"></i>序列号查看方式？</span>
                </el-form-item>
              </div>
              <el-form-item label="优惠券：" prop="input3">
                <el-input v-model.number="ruleForm.input3" placeholder="请输入优惠码（选填）" maxlength="8" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="推荐会员：" prop="input4">
                <el-input v-model.number="ruleForm.input4" :disabled="true" maxlength="11" clearable placeholder="请输入推荐会员的手机号领取积分（选填）">
                  <template #suffix>
                    <div style="margin-right: 25px;margin-top: 1px;">
                      <el-button type="text" size="mini" @click="handleRecommend">
                        <span style="font-size: 16px">我的推荐会员</span>
                      </el-button>
                    </div>
                  </template>
                </el-input>
                <span style="color: red">*新用户通过输入推荐会员手机号，双方同时领取积分，可直接抵扣金额</span>
              </el-form-item>

              <el-form-item label="支付方式：">
                <el-radio v-model="radio" label="wechat">微信支付</el-radio>
                <el-radio v-model="radio" label="alipay" disabled>支付宝</el-radio>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleGoPay">结算支付</el-button>
              </el-form-item>
            </el-form>
          </div>
<!--          <div>类型是{{ oname }}，类型是{{ selectNum }},金额是{{ amount }}最大优惠{{ max }}，输入手机号{{ ruleForm.input1 }}</div>-->
<!--          <div class="des">原创不易，感谢您的大力支持！</div>-->
          <el-dialog :visible.sync="visible" title="序列号查看方式">
            <el-image :src="src4"></el-image>
          </el-dialog>
          <el-dialog
            title=""
            :visible.sync="centerDialogVisible"
            width="360px"
            :before-close="handleClose"
            :close-on-click-modal="false"
            center>
            <span>
              <el-skeleton :loading="loading" animated style="width: 310px;">
                <template slot="template">
                  <div style="text-align: center;width: 310px;height: 450px;">
                    <el-skeleton-item variant="h3" style="width: 70%;height: 30px" />
                    <el-skeleton-item
                      variant="image"
                      style="width: 260px; height: 260px;margin-top: 20px;margin-left: 20px"
                    />
                    <el-skeleton-item variant="h3" style="width: 100%;height: 20px;margin-top: 20px"/>
                    <el-skeleton-item variant="h3" style="width: 70%;height: 20px;margin-top: 5px"/>
                    <el-skeleton-item variant="h3" style="width: 40%;height: 40px;margin-top: 10px"/>
                  </div>
                </template>
                <template>
                  <div style="text-align: center;width: 310px;height: 450px;">
                    <div class="pay_title">微信扫码支付 ¥{{ value }} 元</div>
                    <div class="pay_qrcode">
                      <!--                  <el-image-->
                      <!--                    style="width: 250px; height: 250px"-->
                      <!--                    class="hidden-md-and-down"-->
                      <!--                    :src="url"-->
                      <!--                    fit="fit"/>-->
                      <el-image
                        :src="url"
                        style="width: 250px; height: 250px"
                        class="hidden-md-and-down"
                        fit="fit">
                        <div slot="placeholder" class="image-slot">
                          加载中<span class="dot">...</span>
                        </div>
                      </el-image>
                    </div>
                    <div style="margin-top: 10px">
                      注意：手机完成支付后，不要立即关闭本窗口，请等待支付结果确认，避免重复支付。<p>剩余<span class="pay_timer">{{ second }}</span>秒</p>
                    </div>
                  </div>
                </template>
              </el-skeleton>
            </span>
<!--            <span slot="footer" class="dialog-footer">-->
<!--              <el-button type="primary" @click="centerDialogVisible = false">我知道了</el-button>-->
<!--            </span>-->
          </el-dialog>
          <el-dialog
            title=""
            :visible.sync="errorDialogVisible"
            width="400px"
            :close-on-click-modal="false"
            center>
            <span>
              <el-result icon="error" title="支付失败" sub-title="本次支付失败，请关闭本窗口后重新发起。">
              </el-result>
            </span>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" style="width: 200px" @click="centerDialogVisible = false;errorDialogVisible=false">我知道了</el-button>
            </span>
          </el-dialog>
          <el-dialog
            title="订单信息"
            :visible.sync="payDialogVisible"
            width="700px"
            top="10vh"
            custom-class=""
            :close-on-click-modal="false"
            center
            @open="handlePayInit">
            <div style="margin-left: 70px;margin-right: 90px;margin-bottom: 50px">
              <el-form ref="payForm" :model="payForm" label-width="80px">
                <el-form-item label="手机号">
                  <el-input v-model="ruleForm.input1" :disabled="true" />
                </el-form-item>
                <el-form-item label="优惠券" :style="{'display':ruleForm.input3==''?'none':''}">
                  <el-input v-model="ruleForm.input3" :disabled="true" />
                </el-form-item>
                <el-form-item label="推荐达人" :style="{'display':ruleForm.input4==''?'none':''}">
                  <el-input v-model="ruleForm.input4" :disabled="true" />
                </el-form-item>
                <el-form-item label="所选产品">
                  <el-input v-model="onameTitle" :disabled="true" />
                </el-form-item>
                <el-form-item label="产品金额">
                  <el-input v-model="amount" :disabled="true" />
                </el-form-item>
                <el-form-item label="积分抵扣" prop="input5">
                  <el-input v-model.number="ruleForm.input5" :disabled="true" placeholder="- 0元" maxlength="8" show-word-limit style="width: 80px;margin-right: 8px;font-size: 16px;color: #ff4d4f"></el-input>
                  <span v-if="!isLogin">
                    <el-button type="text" size="mini" style="width: 80px;font-size: 14px;margin-left: 8px" @click="handlePoint">查询我的积分</el-button>
                  </span>
                  <span v-else>
                    <el-checkbox v-model="isChecked" @change="handleCheckChange"><span style="font-size: 14px">可用积分 {{ points }}（本次最高 {{ max }}）</span></el-checkbox>
                    <el-button type="text" size="mini" style="width: 80px;font-size: 14px;margin-left: 10px" @click="handlePointDetail">查询积分明细</el-button>
                  </span>
                  <span class="txt-btn" @click="handleShowPoint"><i class="el-icon-warning-outline"></i>如何获得/使用积分？</span>
                </el-form-item>
                <el-form-item label="支付金额">
                  <div><span style="font-size: 28px; color: #ff4d4f">{{ amount-reduce }}</span> 元</div>
                </el-form-item>
                <el-button type="primary" @click="handle('ruleForm')">确认支付</el-button>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog
            title="手机号登录"
            :visible.sync="loginDialogVisible"
            width="500px"
            top="20vh"
            custom-class=""
            :close-on-click-modal="false"
            :before-close="handleLoginClose"
            center>
            <span>
              <LoginComponent :key="key" :my-phone="ruleForm.input1" @handleChangeLogin="changeLoginStatus"/>
            </span>
          </el-dialog>
          <el-dialog
            title="如何获得/使用积分"
            :visible.sync="showDesDialogVisible"
            width="800px"
            top="20vh"
            custom-class=""
            center>
            <div style="margin: 20px">
              <Points :my-list="tabMenu"/>
            </div>
          </el-dialog>
          <el-dialog
            title="我的积分明细"
            :visible.sync="dialogTableVisible"
            width="900px">
            <div>
              <div style="margin-bottom: 10px">
                累计积分<span class="point-text" style="color: #1E90FF">{{ pointsAll }}</span>
                已用积分<span class="point-text-use">{{ pointsAll-points }}</span>
                可用积分<span class="point-text">{{ points }}</span>

              </div>
              <el-table
                :data="gridData"
                max-height="600px"
                show-summary
                :summary-method="getSummaries">
                <el-table-column property="id" label="序号" width="50" header-align="center" align="center"></el-table-column>
                <el-table-column property="phone" label="手机号" width="150" header-align="center" align="center"></el-table-column>
                <el-table-column property="recommend" label="推荐达人" width="150" header-align="center" align="center"></el-table-column>
                <el-table-column property="from_type" label="积分来源" width="110" header-align="center" align="center"></el-table-column>
                <el-table-column label="积分类别" width="80" header-align="center" align="center">
                  <template slot-scope="scope">
                    <el-tag
                      :type="scope.row.type === '消费' ? 'danger' : 'success'"
                      disable-transitions>{{scope.row.type}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column property="amount" label="积分" width="100" header-align="center" align="center" sortable></el-table-column>
                <el-table-column property="date" label="日期" width="200" header-align="center" align="center" sortable></el-table-column>
              </el-table>
            </div>
          </el-dialog>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import img1 from '@/assets/pay_images/youhui1.png'
import img2 from '@/assets/pay_images/youhui2.png'
import img3 from '@/assets/pay_images/youhui3.png'
import imgInfo from '@/assets/pay_images/info.png'
import { getPayCodeImage, getPayPhoneInfo, getPayResult } from '@/api/pay'
import { urlParam } from '@/utils/url'
// import { tabList } from '@/utils/tabList'
import { getPrice } from '@/utils/tabList'
import { getPoint, getPointDetail } from '@/api/point'
import { encrypt } from '@/utils/encrypt'
import PayBill from '@/views/pay/components/payBill.vue'
import LoginComponent from '@/components/login.vue'
import Points from '@/views/pay/components/points.vue'
import { baseURL } from '@/config/net.config'

export default {
  name: 'Pay',
  components: {
    Points,
    PayBill,
    LoginComponent
    // FixedHeader
  },
  data() {
    const checkInput1 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (value.toString().length !== 11) {
            callback(new Error('手机号必须是11位'))
          } else {
            callback()
          }
        }
      }, 1000)
    }
    const checkInput2 = (rule, value, callback) => {
      if (this.isActive3) {
        if (value === '') {
          callback(new Error('请输入序列号'))
        } else {
          if (value.toString().length !== 16) {
            callback(new Error('序列号必须是16位'))
          } else {
            callback()
          }
        }
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        input1: '',
        input2: '',
        input3: '',
        input4: '',
        input5: ''
      },
      rules: {
        input1: [
          { validator: checkInput1, trigger: 'blur' }
        ],
        input2: [
          { validator: checkInput2, trigger: 'blur' }
        ]
      },
      payForm: {
        oname: '',
        phone: '',
        recommend: '',
        reduce: ''
      },
      form2: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '120px',
      visible: false,
      message: '39',
      para: '',
      type: '2',
      radio: 'wechat',
      isActive1: false,
      isActive2: true,
      isActive3: false,
      src1: img1,
      src2: img2,
      src3: img3,
      src4: imgInfo,
      centerDialogVisible: false,
      errorDialogVisible: false,
      loginDialogVisible: false,
      dialogTableVisible: false,
      payDialogVisible: false,
      showDesDialogVisible: false,
      second: 0,
      timer: 0,
      url: '',
      value: 0,
      id: '',
      param: {},
      indexNum: '1',
      selectNum: 2,
      oname: 'EXE001',
      onameTitle: '',
      tabMenu: [],
      amount: 0,
      max: 0,
      reduce: 0,
      payID: 1,
      isChecked: false,
      key: Date.now(),
      points: 0,
      pointsAll: 0,
      isShowPoint: true,
      isLogin: false,
      gridData: [],
      loading: true,
      websock: null,
      payResult: false,
      trade_no: ''
    }
  },
  created() {
  },
  mounted() {
    console.log('mount事件')
    document.getElementById('appLoaded').style.display = 'block'
    document.getElementById('appLoading').style.display = 'none'
    // this.id = ''
    // 获取链接的参数
    this.param = urlParam
    // 获取tab表格数据
    // this.tabMenu = tabList
    // // console.log(JSON.stringify(this.tabMenu))
    // // console.log('获取的参数为')
    // // console.log(this.param.code)
    // // 如果参数有oname，则查询数组，获取默认的标签
    // if (this.param.oname !== undefined) {
    //   // 返回找的对象值
    //   // const i = this.tabMenu.find(val => val.name === this.param.oname)
    //   // 返回找到位置下标
    //   const i = this.tabMenu.findIndex(val => val.name === this.param.oname)
    //   console.log(i)
    //   if (i !== -1) {
    //     // 注意将数字转字符串，tab的名称是字符串
    //     this.indexNum = i.toString()
    //   }
    // }
    // this.amount = this.tabMenu[ parseInt(this.indexNum)].values[this.selectNum - 1].amount / 100
    // this.max = this.tabMenu[ parseInt(this.indexNum)].values[this.selectNum - 1].max / 100
    // this.payID = this.tabMenu[ parseInt(this.indexNum)].values[this.selectNum - 1].id
    // this.oname = this.tabMenu[ parseInt(this.indexNum)].name
    // this.onameTitle = this.tabMenu[ parseInt(this.indexNum)].title
    // if (this.isChecked) {
    //   this.reduce = this.points > this.max ? this.max : this.points
    //   this.ruleForm.input5 = '- ' + this.reduce + '元'
    // }

    // this.tabMenu = getPrice()
    const i = getPrice().then((res) => {
      // console.log('从服务端获取的价格数据为：')
      // console.log(res)
      this.tabMenu = res
      // console.log('menu数组结果是' + this.tabMenu)

      // console.log(JSON.stringify(this.tabMenu))
      // console.log('获取的参数为')
      // console.log(this.param.code)
      // 如果参数有oname，则查询数组，获取默认的标签
      if (this.param.oname !== undefined) {
        // 返回找的对象值
        // const i = this.tabMenu.find(val => val.name === this.param.oname)
        // 返回找到位置下标
        const i = this.tabMenu.findIndex(val => val.name === this.param.oname)
        console.log(i)
        if (i !== -1) {
          // 注意将数字转字符串，tab的名称是字符串
          this.indexNum = i.toString()
        }
      }
      this.amount = this.tabMenu[ parseInt(this.indexNum)].values[this.selectNum - 1].amount / 100
      this.max = this.tabMenu[ parseInt(this.indexNum)].values[this.selectNum - 1].max / 100
      this.payID = this.tabMenu[ parseInt(this.indexNum)].values[this.selectNum - 1].id
      this.oname = this.tabMenu[ parseInt(this.indexNum)].name
      this.onameTitle = this.tabMenu[ parseInt(this.indexNum)].title
      if (this.isChecked) {
        this.reduce = this.points > this.max ? this.max : this.points
        this.ruleForm.input5 = '- ' + this.reduce + '元'
      }
      return 'ok'
    })
    console.log('获取返回的结果：' + i)
  },
  methods: {
    handle(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 获取支付码
          this.centerDialogVisible = true
          // 隐藏订单界面
          this.payDialogVisible = false
          this.getCodeImage().then((res) => {
            console.log('获取函数返回值')
            console.log(res)
            if (res === 'success') {
              console.log('执行倒计时')
              this.second = 90
              this.timer = setInterval(() => {
                this.second--
                if (this.second === 0) {
                  this.second = 0
                  // 停止
                  clearInterval(this.timer)
                  this.errorDialogVisible = true
                  this.centerDialogVisible = false
                  // 重置骨架屏
                  this.loading = true
                } else {
                  if (this.payResult === true) {
                    // 重置骨架屏
                    this.loading = true
                    // 停止
                    clearInterval(this.timer)
                    this.$router.push({
                      path: '/paySuccess',
                      query: { id: this.trade_no }})
                  } else {
                    // 循环查询支付结果
                    this.handleGetPayResult()
                  }
                }
              }, 1000)
            } else {
              // eslint-disable-next-line no-unused-vars
              this.centerDialogVisible = false
              this.$message.error('获取支付码异常失败，请重试')
            }
            // this.para = window.location.search.substring(1) + '&type=' + this.type + '&pay_type=' +
            //   this.radio + '&phone=' + this.ruleForm.input1 + '&ud=' + this.ruleForm.input2 + '&cp=' + this.ruleForm.input3
            // window.location.href = 'getPayBill.php?' + this.para
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
      // 上次接口有问题，用来提示无法支付问题
      // this.$alert('非常抱歉，因后端支付接口审查问题，暂无支付，如紧急需求可联系vba2022@163.com处理', '提示', {
      //   confirmButtonText: '确定',
      //   callback: action => {
      //     this.$message({
      //       type: 'warning',
      //       message: `action: ${ action }`
      //     });
      //   }
      // });
    },
    handle1() {
      this.message = '6'
      this.isActive1 = true
      this.isActive2 = false
      this.isActive3 = false
      this.type = '1'
    },
    handle2() {
      this.message = '39'
      this.isActive1 = false
      this.isActive2 = true
      this.isActive3 = false
      this.type = '2'
    },
    handle3() {
      this.message = '169'
      this.isActive1 = false
      this.isActive2 = false
      this.isActive3 = true
      this.type = '3'
    },
    handle4() {
      this.visible = true
    },
    handleClose(done) {
      done()
      clearInterval(this.timer)
      // 将支付金额置零
      this.value = 0
      this.loading = true
    },
    handleRecommend() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.input1 == '') {
        this.$message.error('手机号不能为空')
        return
      }
      this.$prompt('请输入推荐达人的手机号码（在会员有效期内）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^1[3456789]\d{9}$/,
        inputErrorMessage: '手机号格式不正确',
        maxLength: '11'
      }).then(({ value }) => {
        // 判断手机号不能相等
        // eslint-disable-next-line eqeqeq
        if (value == this.ruleForm.input1 || this.ruleForm.input1 === '') {
          this.$message.warning('手机号不能为空，且不能与购买手机号一样')
          return
        }
        // 获取手机号是否在有效期内
        const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
        var params = {
          'phone': this.ruleForm.input1,
          'recommand': value,
          'timestamp': timestamp
        }
        getPayPhoneInfo(params).then((res) => {
          if (res['code'] === 200) {
            console.log('验证通过')
            this.ruleForm.input4 = value
            this.$message.success('添加成功')
          } else if (res['code'] === 500) {
            this.$message.error('抱歉，您已是会员，非新用户暂无法参与推荐达人活动')
            this.ruleForm.input4 = ''
          } else {
            this.$message.error('添加失败，该手机号非会员期')
            this.ruleForm.input4 = ''
          }
        })
      }).catch(() => {
        this.ruleForm.input4 = ''
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    handleGetPayResult() {
      var params = {
        'id': this.trade_no
      }
      getPayResult(params).then((res) => {
        console.log('定时循环查询支付结果')
        console.log(res)
        if (res['code'] === 200) {
          this.payResult = true
        }
      })
    },
    async getCodeImage() {
      // Math.random()*(max-min)+min),生成10-100的随机数
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      // 定义参数
      // 对敏感数据加密
      console.log('开始加密数111')
      // eslint-disable-next-line no-unused-vars
      const vdata = {
        'type': this.type,
        'pay_type': this.radio,
        'cp': this.ruleForm.input3,
        'ud': this.ruleForm.input2,
        'oname': this.oname,
        'payID': this.payID,
        'from_amount': this.amount,
        'max': this.max,
        'reduce': this.reduce,
        'recommend': this.ruleForm.input4
      }
      // 先转换成字符串，再加密
      var edata = encrypt(JSON.stringify(vdata))
      console.log('加密的数组' + edata)
      var params = {
        'id': this.id,
        'phone': this.ruleForm.input1,
        'timestamp': timestamp,
        'biosCode': this.param.code,
        'attach': edata
        // 'type': this.type,
        // 'pay_type': this.radio,
        // 'cp': this.ruleForm.input3,
        // 'ud': this.ruleForm.input2,
        // 'oname': this.oname,
        // 'payID': this.payID,
        // 'amount': this.amount,
        // 'max': this.max,
        // 'reduce': this.reduce
      }
      const imgResult = await getPayCodeImage(params).then((res) => {
        console.log('获得返回支付二维码数据结果')
        console.log(res)
        console.log(res['code'])
        if (res['code'] === 200) {
          // 获取二维码图片成功
          this.url = baseURL + res['data']['image_url']
          // 支付金额以后端返回为准
          this.value = res['data']['amount'] / 100
          // 返回订单号
          this.trade_no = res['data']['trade_no']
          // 取消骨架屏
          this.loading = false
          // 返回成功结果给结果
          return 'success'
        } else {
          // 获取二维码失败
          console.log('获得支付二维码失败')
          this.$message.error('获取支付二维码失败，请重试')
          // 返回成功结果给结果
          return 'fail'
        }
      })
      console.log('测试获取then的值')
      console.log(imgResult)
      // 以下将值可以返回调用函数中，在then中获取
      return new Promise((resolve, reject) => {
        // resolve('success')
        resolve(imgResult)
      })
    },
    changeName(para) {
      console.log('父组件事件，获得子组件值' + para)
      // this.selectNum = para.id
      // this.amount = para.amount / 100
      // this.max = para.max / 100
      // this.message = para.amount / 100
      // this.payID = para.id
      // 如果是后台传回的，数字是字符串，需要手动转换
      this.selectNum = parseInt(para.id)
      this.amount = parseInt(para.amount) / 100
      this.max = parseInt(para.max) / 100
      this.message = parseInt(para.amount) / 100
      this.payID = parseInt(para.id)

      if (this.isChecked) {
        this.reduce = this.points > this.max ? this.max : this.points
        this.ruleForm.input5 = '- ' + this.reduce + '元'
      }
      console.log(this.selectNum)
      // if (this.selectNum === 4) {
      //   this.isActive3 = true
      // } else {
      //   this.isActive3 = false
      // }
    },
    getTab(tab, event) {
      // this.oname = tab.paneName
      console.log(tab, event)
      this.oname = this.tabMenu[tab.paneName].name
      this.onameTitle = this.tabMenu[tab.paneName].title
      this.amount = this.tabMenu[tab.paneName].values[this.selectNum - 1].amount / 100
      this.max = this.tabMenu[tab.paneName].values[this.selectNum - 1].max / 100
      this.payID = this.tabMenu[tab.paneName].values[this.selectNum - 1].id

      if (this.isChecked) {
        this.reduce = this.points > this.max ? this.max : this.points
        this.ruleForm.input5 = '- ' + this.reduce + '元'
      }
      console.log(this.oname)
    },
    handlePoint() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.input1 == '') {
        this.$message.error('手机号不能为空')
        return
      }
      // Math.random()*(max-min)+min),生成10-100的随机数
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      var params = {
        // 'id': this.urlParam.code,
        // 'name': this.urlParam.oname,
        // 'mac': this.urlParam.ma,
        'phone': this.ruleForm.input1,
        'timestamp': timestamp
      }
      getPoint(params).then((res) => {
        console.log('获得返回数据33')
        console.log(res)
        if (res['code'] === 200) {
          console.log('验证通过')
          // 设置登录状态
          this.isLogin = true
          // 读取积分值
          this.points = res['data']['sums'] / 100
          this.pointsAll = res['data']['total'] / 100
        } else if (res['code'] === 700) {
          // 登录验证失败，跳转到登录页,并传入跳转路径，确保登录成功后直接跳转回本页
          // this.$router.push({
          //   path: '/login',
          //   query: { redirectUrl: '/pay' }})
          // 验证登录失败，则弹出登录框
          this.loginDialogVisible = true
        } else {
          // 获取可用积分失败，其他未知错误消息
          this.points = 0
          const errorMsg2 = `${res['msg']}`
          this.$message.error(errorMsg2)
        }
      })
    },
    changeLoginStatus() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.input1 == '') {
        this.$message.error('手机号不能为空')
        return
      }
      // 登录成功，则获取
      this.loginDialogVisible = false
      // 重新调用登录
      this.handlePoint()
    },
    handleLoginClose() {
      // 关闭登录框时的事件,通过更改key值，重新渲染组件
      this.key = Date.now()
      this.loginDialogVisible = false
    },
    handleCheckChange() {
      if (this.isChecked) {
        // 如果选中积分,判断最大优惠值
        this.reduce = this.points > this.max ? this.max : this.points
      } else {
        this.reduce = 0
      }
      this.ruleForm.input5 = '- ' + this.reduce + '元'
    },
    handlePointDetail() {
      // 显示积分明细
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      var params = {
        // 'id': this.urlParam.code,
        // 'name': this.urlParam.oname,
        // 'mac': this.urlParam.ma,
        'phone': this.ruleForm.input1,
        'timestamp': timestamp
      }
      getPointDetail(params).then((res) => {
        console.log('获得积分明细数据')
        console.log(res)
        if (res['code'] === 200) {
          // 读取积分值
          this.gridData = res['data']
          // 显示数据
          this.dialogTableVisible = true
        } else if (res['code'] === 700) {
          // 登录验证失败，跳转到登录页,并传入跳转路径，确保登录成功后直接跳转回本页
          // this.$router.push({
          //   path: '/login',
          //   query: { redirectUrl: '/pay' }})
          // 验证登录失败，则弹出登录框
          this.loginDialogVisible = true
        } else {
          // 获取可用积分失败，其他未知错误消息
          this.points = 0
          const errorMsg2 = `${res['msg']}`
          this.$message.error(errorMsg2)
        }
      })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = '可用积分'
          return
        }
        if (index === 5) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
        }
      })
      return sums
    },
    handleGoPay() {
      // eslint-disable-next-line eqeqeq
      if (this.param.code == '' || this.param.code === undefined) {
        this.$message.error('页面出错，请从原软件点击重新进入')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.input1 == '') {
        this.$message.error('手机号不能为空')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.input1 == this.ruleForm.input4) {
        this.$message.error('手机号与推荐达人手机不能一样')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.input3 != '' && this.ruleForm.input4 != '') {
        this.$message.error('优惠券和推荐达人不能同时使用！')
        return
      }
      this.payDialogVisible = true
    },
    handlePayInit() {
      // 打开订单页面时，积分抵扣状态清空，担心坏人直接修改
      this.isChecked = false
      this.isLogin = false
      this.ruleForm.input5 = '- 0元'
      console.log('打开了订单页面')
    },
    handleShowPoint() {
      this.showDesDialogVisible = true
    }

  }
}

</script>
<style scoped lang="scss">
#appLoading {
  width: 100%;
  height: 100%;
}
#appLoading span {
  position: absolute;
  display: block;
  color: #4fc1cc;
  font-size: 50px;
  line-height: 50px;
  top: 50%;
  left: 50%;
  width: 200px;
  height: 100px;
  /*background: url('../../assets/images/load2.gif') center center no-repeat ;*/
  -webkit-transform: translateY(-50%)  translateX(-50%);
  transform: translateY(-50%)  translateX(-50%);
}
.el-form-item{
  text-align: left;
}
.el-button{
  width: 100%;
  /*background-color: #1E90FF;*/
  /*color:#FFFFFF;*/
  font-size: 20px;
}
/*.el-button:hover{*/
/*  background-color: #60acf6;*/
/*  color:#FFFFFF;*/
/*}*/
.active{
  border: 4px #E6A23C solid;
}
.el-header {
  background-color: #1E90FF;
  color: #FFFFFF;
  line-height: 60px;
}
.des{
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #1E90FF;
  margin-top: 30px;
}
.main{
  text-align: center;
  padding-left: 20%;
}
.main-img{
  padding: 0 6px;
  float: left;
  width: 23%;
}
.clearfix:after {
  content: "";
  display: table;
  clear: both;
}
.img:hover{
  border: 4px #E6A23C solid;

}
/*.img{*/
/*  width: 50px;*/
/*  height: 50px;*/
/*}*/
.content{
  padding-left: 20%;
  width:600px;
  font-size: 16px;
}
.txt-btn{
  color: #1E90FF;
  display: block;
}
.txt-btn:hover{
  color: red;
  cursor: pointer;
}
.pay_title{
  margin: 10px;
  font-size: 24px;
}
.pay_qrcode{
  background: #20a53a;
  margin-top: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.pay_timer{
  font-size: 24px;
  margin-top: 10px;
  color: #ff4d4f;
  display: inline-block;
  width: 35px;
}
.tab-item{
  width: 850px;
  //left: calc((100vh - 850px)/2);
  padding-left: 20%;;

}
.car{
  display: flex;
  justify-content:space-around;
  padding-top: 20px;
  padding-bottom: 30px;
}
.dialog-login{
  background: #4fc1cc;
}
.point-text{
  font-size: 20px;
  margin-right: 15px;
  margin-left: 5px;
}
.point-text-use{
  font-size: 20px;
  color: #ff4d4f;
  margin-right: 15px;
  margin-left: 5px;
}
</style>
<style lang="scss">
//修改el-tab的样式
//每一项元素
.el-tabs__item {
  height: 50px;
  width: fit-content;
  font-size: 16px;
  padding-left: 20px;
  padding-top: 5px;
}
// 点击的某一项时改变字体颜色
.el-tabs__item.is-active {
  font-weight: bold;
}
.el-alert {
  margin: 10px 0 0;
  line-height: 10px;
}
.el-alert:first-child {
  margin: 0;
}
</style>
